/** Skeleton loader for the News Feed while posts are fetching. */
export default function FeedSkeleton({ count = 3 }) {
  return (
    <div className="space-y-4" data-testid="feed-skeleton" aria-busy="true">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="csc-card p-5 animate-pulse">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-[rgba(0,170,255,0.18)]/60" />
            <div className="flex-1 space-y-2">
              <div className="h-3 w-32 rounded bg-[rgba(0,170,255,0.18)]/60" />
              <div className="h-2 w-20 rounded bg-[rgba(0,170,255,0.18)]/40" />
            </div>
          </div>
          <div className="mt-4 space-y-2">
            <div className="h-3 w-full rounded bg-[rgba(0,170,255,0.18)]/40" />
            <div className="h-3 w-11/12 rounded bg-[rgba(0,170,255,0.18)]/40" />
            <div className="h-3 w-9/12 rounded bg-[rgba(0,170,255,0.18)]/40" />
          </div>
          <div className="mt-4 h-40 rounded bg-[rgba(0,170,255,0.18)]/30" />
          <div className="mt-4 flex gap-2">
            <div className="h-7 w-20 rounded bg-[rgba(0,170,255,0.18)]/40" />
            <div className="h-7 w-20 rounded bg-[rgba(0,170,255,0.18)]/40" />
            <div className="h-7 w-20 rounded bg-[rgba(0,170,255,0.18)]/40" />
          </div>
        </div>
      ))}
    </div>
  );
}
